import { NgModule } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { OverlayComponent } from './overlay/overlay.component';

@NgModule({
    imports: [HeaderComponent, FooterComponent, OverlayComponent],
    exports: [HeaderComponent, FooterComponent, OverlayComponent],
})
export class AppLayerModule {}
